import React from "react";
import { useSelector } from "react-redux";
import { onKeyDown } from "../../../../../service";
import AuthorIcon from '../../.././../../assests/MaterialLibrary/Author.png';
import classes from './UploadAuxiliary.module.css';

const UploadStep3 = ({ auxiliary, setMessage }) => {

    const user = useSelector(state => state.auth.user);
    const texts = useSelector(state => state.translate.texts);

    return (
        <>
            <div className={classes.Details}>
                <div className={classes.AuthorContainer}>
                    <img src={AuthorIcon} alt='AuthorIcon' />
                    <div className={classes.Author}>{texts.author} {user.firstName + " " + user.lastName}</div>
                </div>
                <div className={classes.OpeningImageContainer}>
                    {auxiliary?.thumbnail ? <img className={classes.OpeningImage} src={URL.createObjectURL(auxiliary.thumbnail)} alt="thumbanil" /> : ''}
                </div>
                <div className={classes.newAuxiliaryName}>{auxiliary?.name}</div>
            </div>
            <div className={classes.uploadAuxiliarySuccess}>{texts.uploadAuxiliarySuccess}</div>
            <div className={`${classes.ImportBtn} ${classes.Btn}`} onClick={() => setMessage(false)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setMessage(false))}>{texts.close}</div>
        </>
    )
}

export default UploadStep3;